import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

import Login from 'pages/Login';
import Home from 'pages/Home';
import Users from 'pages/Users';
import User from 'pages/User';
import Stations from 'pages/Stations';
import StationsMap from 'pages/StationsMap';
import StationsUsersGroups from 'pages/StationsUsersGroups';
import StationsUsersGroup from 'pages/StationsUsersGroup';
import Station from 'pages/Station';
import Satellites from 'pages/Satellites';
import Satellite from 'pages/Satellite';
import RBV3Stations from 'pages/RBV3Stations';
import RBV3Station from 'pages/RBV3Station';
import Profile from 'pages/Profile';
import ResetPassword from 'pages/ResetPassword';
import NotFound from 'pages/NotFound';
import Submenu from 'pages/Submenu';
import paths from './paths';
import PrivateRoute from './PrivateRoute';

const RouterComponent = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={paths.LOGIN} component={Login} />
        <Route exact path={paths.RESET_PASSWORD} component={ResetPassword} />
        {/* == USERS == */}
        <PrivateRoute path={paths.ADD_USER} component={User} />
        <PrivateRoute path={paths.USER} component={User} />
        <PrivateRoute path={paths.MODIFY_USER} component={User} />
        <PrivateRoute path={paths.USERS} component={Users} />

        {/* == STATIONS==  */}
        {/* <Route path={paths.ADD_STATION} component={Station} /> */}
        <PrivateRoute path={paths.ADD_STATION} component={Station} />
        <PrivateRoute path={paths.STATION} component={Station} />
        <PrivateRoute path={paths.STATIONS} component={Stations} />
        <PrivateRoute path={paths.STATIONS_MAP} component={StationsMap} />

        {/* == STATIONS USERS GROUPS == */}
        <PrivateRoute
          path={paths.ADD_STATIONS_USERS_GROUP}
          component={StationsUsersGroup}
        />
        <PrivateRoute
          path={paths.STATIONS_USERS_GROUP}
          component={StationsUsersGroup}
        />
        <PrivateRoute
          path={paths.STATIONS_USERS_GROUPS}
          component={StationsUsersGroups}
        />

        {/* == SATELLITES == */}
        <PrivateRoute path={paths.ADD_SATELLITE} component={Satellite} />
        <PrivateRoute path={paths.SATELLITE} component={Satellite} />
        <PrivateRoute path={paths.SATELLITES} component={Satellites} />

        {/* == RBV3 == */}
        <PrivateRoute path={paths.RBV3STATION} component={RBV3Station} />
        <PrivateRoute path={paths.RBV3STATIONS} component={RBV3Stations} />

        {/* == PROFILE == */}
        <PrivateRoute path={paths.PROFILE} component={Profile} />
        {/* <PrivateRoute path={paths.SECTION} component={Section} /> */}
        {/* <Route path={paths.SECTION} component={Section} /> */}
        <PrivateRoute path={paths.SUBMENU_1} component={Submenu} />
        <PrivateRoute path={paths.SUBMENU_2} component={Submenu} />
        <PrivateRoute path={paths.ROOT} component={Home} />
        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
};

export default RouterComponent;
